import { ArrowRightIcon, Button } from '@quickmd-llc/design-system';
import { useIntakeForm } from '../../context/useIntakeForm';

type Props = { isLoading?: boolean; onClick?: () => void };

function SubmitButton({ isLoading, onClick }: Props) {
  const { editQuestion } = useIntakeForm();
  const buttonText = editQuestion ? 'Save' : 'Next';

  function handleClick() {
    if (onClick) {
      onClick();
    }
  }

  return (
    <Button
      className="mt-auto w-full"
      loading={isLoading}
      onClick={handleClick}
      type="submit"
    >
      {buttonText} <ArrowRightIcon />
    </Button>
  );
}

export { SubmitButton };
